import type { FC } from "react";

import { SearchDefaultIcon } from "@jti/brand-icons/search-default";
import { SearchFullIcon } from "@jti/brand-icons/search-full";

import styles from "./SearchHeaderButton.module.scss";

type SearchHeaderButtonProps = {
  isOpened: boolean;
  onOpen: () => void;
  onClose: () => void;
};

export const SearchHeaderButton: FC<SearchHeaderButtonProps> = ({ isOpened, onClose, onOpen }) => {
  const toggle = (isOpened: boolean) => {
    if (isOpened) {
      onClose();
    } else {
      onOpen();
    }
  };
  return (
    <div data-search-button data-testid="search">
      <button type="button" aria-label="searchButton" onClick={() => toggle(isOpened)} className={styles.searchButton}>
        <span className={styles.searchIcon}>
          {isOpened ? (
            <SearchFullIcon className={styles.searchIcon} />
          ) : (
            <SearchDefaultIcon className={styles.searchIcon} />
          )}
        </span>
      </button>
    </div>
  );
};
